import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import CreateIcon from "@mui/icons-material/Create";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
// import EmailIcon from "@mui/icons-material/Email";
// import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ApartmentIcon from '@mui/icons-material/Apartment';
import InfoIcon from '@mui/icons-material/Info';
import avtar from "../../assets/images/Profile-Picture.jpg";

function MobileTenantInfo() {
    const navigate = useNavigate();
    return (
    <>
      <div>
        <div className="drawerFixedPatch"></div>
        <div className="drawerWithTop">
          {/* <MobileDrawer /> */}
          <ArrowBackIcon
            className="backArrowMobil"
            onClick={() => navigate("/MobileProfile")}
          />
          <h1>Tenant List</h1>
        </div>
      </div>
      <div className="wraperMobile">
        <div className="sectionMobile">
          <div className="famDetailsListMainMob">
            <div className="famDetailsListInrMob" onClick={()=>navigate('/MobileTenantDetails')}>
              <div className="famDetailsListTo">
                <div className="alignfamDetailsListToPro">
                  <img src={avtar} className="useImage" alt='altimg'/>
                  <div className="detailsDiMob">
                    <h1>Demo text</h1>
                    <div className="mobWithIco">
                      <LocalPhoneIcon />
                      <p>9881789836</p>
                    </div>
                    <div className="mobWithIco">
                      <ApartmentIcon />
                      <p>Sai Plaza/A/F-101</p>
                    </div>
                  </div>
                </div>
                
              </div>
              <div className="famDetailsListBot">
                <p>
                  <InfoIcon /> <span>Tenant Since: 01/01/2022</span>
                </p>
              </div>
            </div>
  
            <div className="famDetailsListInrMob" onClick={()=>navigate('/MobileTenantDetails')}>
              <div className="famDetailsListTo">
                <div className="alignfamDetailsListToPro">
                  <img src={avtar} className="useImage" alt='altimg'/>
                  <div className="detailsDiMob">
                    <h1>Demo text</h1>
                    <div className="mobWithIco">
                      <LocalPhoneIcon />
                      <p>9881789836</p>
                    </div>
                    <div className="mobWithIco">
                      <ApartmentIcon />
                      <p>Sai Plaza/A/F-102</p>
                    </div>
                  </div>
                </div>
                
              </div>
              <div className="famDetailsListBot">
                <p>
                  <InfoIcon /> <span>Tenant Since: 01/01/2022</span>
                </p>
              </div>
            </div>
  
            <div className="famDetailsListInrMob" onClick={()=>navigate('/MobileTenantDetails')}>
              <div className="famDetailsListTo">
                <div className="alignfamDetailsListToPro">
                  <img src={avtar} className="useImage" alt='altimg'/>
                  <div className="detailsDiMob">
                    <h1>Demo text</h1>
                    <div className="mobWithIco">
                      <LocalPhoneIcon />
                      <p>9881789836</p>
                    </div>
                    <div className="mobWithIco">
                      <ApartmentIcon />
                      <p>Sai Plaza/A/F-103</p>
                    </div>
                  </div>
                </div>
                
              </div>
              <div className="famDetailsListBot">
                <p>
                  <InfoIcon /> <span>Tenant Since: 01/01/2022</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
    )
}

export default MobileTenantInfo